import { features } from './features'; 

features.applicationType = 'agrogest';

// Usuarios
features.showUsuarios = false;
features.adminCanSeeAllRecords = true;
features.userCanSeeClientes = true;
features.userCanSeeCostes = false;
features.showUsuariosFirma = true;
features.showBackup = true;
features.canRecoverPassword = false;
features.canRegister = false;

// Clientes
features.clienteName = 'Titular';
features.clientesName = 'Titulares';
features.hasClients = false;
features.showClientesRegepa = true;
features.clientesMostrarTodosDefault = true;

// Fincas
features.fincaName = 'Finca';
features.fincasName = 'Fincas';
features.activateSIEX = true;
features.showCargaPAC = true;
features.showCultivosBajoAguaFields = true;
features.showFincasGenGml = false;

// Sectores
features.sectorName = 'Sector';
features.sectoresName = 'Sectores';
features.showPartida = true;

// Parcelas
features.showParcelasEstacion = true;
features.showParcelasFincasCol = false;
features.showParcelasProvinciaCol = true;
features.showParcelasMunicipioCol = true;
features.showAgrupacionEntidadEnParcela = true;
features.showParcelasFincasCol = true;
features.showParcelasActivoCol = false;

// Mapas
features.showMapaLabels = true;
features.showMapaRutas = true;
features.showMapaTratamientos = true;
features.showVentusky = true;
features.showMeteoBtn = true;

// Analisis
features.showAnalisis = true;
features.showAnalisisSectorParcelas = true;
features.showAnalisisNumeroAnalisis = true;

// Aplicadores
features.aplicadorName = 'Trabajador';
features.aplicadoresName = 'Trabajadores';
features.showAplicadoresFichajes = true;
features.showAplicadoresPartes = true;
features.showMultiselectAplicadores = true;
features.filterAplicadoresByClient = false;
features.showConsultaRopo = true;
features.showTrabajadoresCargos = true;

// Maquinarias
features.showTractorBoquillas = true;
features.showTractorMarcha = true;
features.showTractorPresion = true;
features.showTractorRPM = true;
features.showTractorVelocidad = true;
features.showTractorKmRecorridos = true;
features.showMaquinariaClienteAsignado = false;
features.showTareasMaquinaria = true;
features.showMaquinariaAdjuntoPdf = true;

// Tratamientos
features.showDesplazamientoObra = false;
features.puedeImprimir = true;
features.showTratamientosAllProductos = true;
features.showTratamientosExportCsv = true;
features.showPhCaldo = false;
features.showEnviarWhatsapp = false;
features.showEnviarCorreo = true;
features.showOrdenAplicacionProductos = true;
features.showTareasFitoMotivoJustificacion = false;
features.showTareasFitoLote = true;
features.showAllCultivosPrecedentes = true;
features.showRecetaPascualCabedo = true;
features.showTecnicoAsignado = false;
features.showAplicados = false;
features.showFitoFechaReceta = false;
features.enableLegalMode = true;
features.tareasHorasTotales = false;
features.showTareasFitoHoras = true;

// Tareas Fertilizantes
features.showNPK = false;
features.showAbonado = true;
features.showFertilizantesFormShort = true;
features.showTareasFertiGramos = false;
features.showFertilizantesS = true;
features.showFertilizantesAlbaranFactura = true;
features.showWidthFertilizanteNombre = true;
features.showTareasFertiGramos = true;
features.showTareasFertilizantesTipoFertilizacion = true;
features.showTareasFertiObservaciones = true;

// Tareas Genéricas
features.showTareasOtros = true;
features.showTareasOtrosDuracion = true;

// Tareas Bio
features.showTareasBio = true;
features.showTareasBioParcelaMultiple = true;
features.showTareasBioExportCsv = false;

// Tareas Siembra
features.showTareasSiembra = true;
features.showTareasSiembraProductos = true;

// Costes
features.showCostes = true;
features.showCostesOtros = true;

// Ventas
features.showVentasComercioProveedor = true;
features.persisteIdComercio = true;

// Stock
features.showStock = true;
features.showStockProveedor = true;
features.showStockProveedorClienteDropdown = true;
features.showStockEnvase = false;
features.showStockSemilla = true;
features.showStockReto = false;
features.showStockTipoDeDato = true;

// Visitas
features.showVisitas = true;
features.showVisitasConsultas = true;
features.showEnviarWhatsappVisitas = true;
features.showEnviarCorreoVisitas = true;
features.showVisitasUploadPhotos = true;
features.showVisitasCultivos = true;
features.showVisitasVariedades = false;
features.hiddenVisitasCerezo = true;
features.showLocationLatLng = true;
features.showVisitasCamposPersonalizados = true;

// Otros
features.showEstadisticas = false;
features.showControlRiego = false;
features.showCalendarioTareas = true;
features.showTareasAgroambiental = true;
features.showEcorregimenes = true;
features.showVentas = true;
features.timeStartStopTareas = true;
features.horaFechaInicioActualPorDefecto = true;


export const environment = {
    production: true,
    v: '2',
    serverUrl: 'https://plantanova.agrogest.com/',
    logoUrl: 'assets/logo_plantanova.png',
    appName: 'plantanova',
    features: features
};
